import { render } from "./Spinner.vue?vue&type=template&id=3fa9bada&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=ts"
export * from "./Spinner.vue?vue&type=script&lang=ts"

import "./Spinner.vue?vue&type=style&index=0&id=3fa9bada&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-3fa9bada"
/* custom blocks */
import block0 from "./Spinner.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script